import { render, staticRenderFns } from "./NtdInstituteEditDialog.vue?vue&type=template&id=7757dc0d"
import script from "./NtdInstituteEditDialog.vue?vue&type=script&lang=ts"
export * from "./NtdInstituteEditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports